module.exports = __webpack_public_path__ + "img/c6.69525873.jpg";